import $ from 'jquery';

export default {
  purposeUpdate(viewModel, event) {
    const customPurposeInput = document.querySelector(
      'input[name="custom_appointment_purpose"]'
    );
    if (event.target.value === 'other') {
      $(customPurposeInput).slideDown();
    } else {
      $(customPurposeInput).slideUp();
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/modules/contact-appointment-methods.js